<div class="page-title">Brindes MGM</div>

<app-table
  [elements]="cycles"
  [cols]="columns"
  [lazy]="false"
  [defaultRows]="25"
  [sortField]="'referenceMonth'"
  [sortOrder]="-1"
  [modelName]="'ciclos'"
  addLabel="Novo Ciclo"
  [addButtonRouterLink]="'new'"
></app-table>
